import React from 'react';


//import TopBar from '../components/common/topBar';
import { Outlet } from 'react-router-dom';


const Main: React.FC = () => {
    return (

        <div>
            {/*
            <div>
                <TopBar />
            </div>
            <div>
                <HorizontalMenu />
            </div>
            */}
            <Outlet />
        </div>
    );
};

export default Main;
